"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AriaTelemetry_1 = require("../telemetry/AriaTelemetry");
var createTelemetry = function (debug) {
    if (debug === void 0) { debug = false; }
    AriaTelemetry_1.default.setDebug(debug);
    return AriaTelemetry_1.default;
};
exports.default = createTelemetry;
//# sourceMappingURL=createTelemetry.js.map